import { CSSProperties } from 'react';
import { TransitionStatus } from 'react-transition-group/Transition';
import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  transitionStyle: CSSProperties;
  buttonLeft: FelaCSS;
  buttonRight: FelaCSS;
  transitionStyles: Record<TransitionStatus, CSSProperties>;
}

const styles = (): IStyles => ({
  transitionStyle: {
    transition: `opacity 100ms ease-in-out`,
    opacity: 0,
  },
  transitionStyles: {
    entering: { opacity: 1 },
    entered: { opacity: 1 },
    exiting: { opacity: 0 },
    exited: { opacity: 0 },
    unmounted: {},
  },
  buttonLeft: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    left: '3%',
    background: colors.white,
    borderRadius: '100px',
    ':hover': {
      boxShadow: '0px 5px 20px rgba(0, 0, 0, 0.1)',
    },
  },
  buttonRight: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    right: '3%',
    background: colors.white,
    ':hover': {
      boxShadow: '0px 5px 20px rgba(0, 0, 0, 0.1)',
    },
  },
});

export default styles;
